// Disposizione delle file di tracker disegnate sul fondo dell'app (AppBackground): dal mockup, cinque file in prospettiva
// (lontane in alto, piccole e chiare; vicine in basso, grandi e scure) con i pannelli inclinati come in una giornata di sole.
// Deterministica: stesso risultato a ogni render, così il disegno non «salta» e i test sono ripetibili.

export interface TrackerCampo {
  fila: number;
  x: number;
  y: number;
  scala: number;
  // inclinazione del pannello in gradi
  angolo: number;
  opacita: number;
}

export const LARGHEZZA_CAMPO = 1200;
export const ALTEZZA_CAMPO = 300;

export function generaFileTracker(righe = 5): TrackerCampo[] {
  const tracker: TrackerCampo[] = [];
  for (let fila = 0; fila < righe; fila++) {
    const t = righe === 1 ? 1 : fila / (righe - 1);
    // la distanza tra le file cresce verso il basso, come in prospettiva
    const y = 78 + 196 * Math.pow(t, 1.25);
    const scala = 0.42 + 0.78 * t;
    const quanti = 14 + fila * 3;
    for (let i = 0; i < quanti; i++) {
      tracker.push({
        fila,
        x: Math.round(((i + 0.5) * LARGHEZZA_CAMPO) / quanti),
        y: Math.round(y * 10) / 10,
        scala: Math.round(scala * 1000) / 1000,
        // tutti i pannelli guardano verso il sole basso, con piccole differenze fila per fila
        angolo: Math.round((-17 + fila * 1.5 + Math.sin(i * 0.9 + fila) * 2.2) * 10) / 10,
        opacita: Math.round((0.3 + 0.55 * t) * 100) / 100,
      });
    }
  }
  return tracker;
}
